import { render } from "./DashboardSelecton.vue?vue&type=template&id=b8a60016&scoped=true"
import script from "./DashboardSelecton.vue?vue&type=script&lang=js"
export * from "./DashboardSelecton.vue?vue&type=script&lang=js"

import "./DashboardSelecton.vue?vue&type=style&index=0&id=b8a60016&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_4cebc095a9b5bcc882fa23a41973ce86/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8a60016"]])

export default __exports__